import React from "react";
import {Button, Modal} from "react-bootstrap";

interface ActionErrorModalProps {
    show: boolean;
    onHide: () => void;
    title?: string;
    messages: string[];
}

// Shows why a state change was refused. A table cell has no room for an explanation,
// and the previous behaviour was to leave a spinner running with nothing said at all.
const ActionErrorModal: React.FC<ActionErrorModalProps> = ({show, onHide, title, messages}) => (
    <Modal show={show} onHide={onHide} aria-labelledby="action-error-title">
        <Modal.Header closeButton>
            <Modal.Title id="action-error-title">{title ?? 'Action could not be completed'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {messages.map((message, index) => (
                <p key={index} className={index === messages.length - 1 ? 'mb-0' : undefined}>{message}</p>
            ))}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>Close</Button>
        </Modal.Footer>
    </Modal>
)

export default ActionErrorModal;
